var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccordianCart(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3484",
    "data-name": "Group 3484",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.773,
    height: 15.492,
    viewBox: "0 0 16.773 15.492",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-cart",
    "data-name": "Icon ionic-ios-cart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M11.5,29.093a.968.968,0,1,1-.968-.968A.968.968,0,0,1,11.5,29.093Z",
    transform: "translate(-6.017 -14.569)",
    fill: "#41a6e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M27.284,29.093a.968.968,0,1,1-.968-.968.968.968,0,0,1,.968.968Z",
    transform: "translate(-12.747 -14.569)",
    fill: "#41a6e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M20.149,7.248a.237.237,0,0,0-.21-.169L6.8,5.808a.4.4,0,0,1-.3-.19,4.107,4.107,0,0,0-.492-.75c-.311-.379-.9-.367-1.968-.375a.588.588,0,0,0-.657.569.577.577,0,0,0,.629.569,5.359,5.359,0,0,1,1.049.077c.19.056.343.367.4.637a.015.015,0,0,0,0,.012c.008.048.081.411.081.415l1.613,8.535a3.137,3.137,0,0,0,.585,1.44,1.61,1.61,0,0,0,1.327.653h9.543a.573.573,0,0,0,.581-.54.562.562,0,0,0-.565-.589H9.061a.469.469,0,0,1-.335-.113,1.81,1.81,0,0,1-.464-1.049l-.173-.956a.022.022,0,0,1,.016-.024l11.2-1.9a.236.236,0,0,0,.2-.21l.645-4.671A.23.23,0,0,0,20.149,7.248Z",
    transform: "translate(-3.382 -4.493)",
    fill: "#41a6e9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordianCart);
export default __webpack_public_path__ + "static/media/accordianCart.1bb8582aa2ffc441f432626a218b0006.svg";
export { ForwardRef as ReactComponent };